<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-privacy-setting"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="page-wrapper">
                        <div class="page-bg"></div>
                        <div class="page-content">
                            <TopBarDark
                                :title="lbl.profile.user_consent"
                                @clickBack="clickBack()">
                            </TopBarDark>
                            <div class="privacy-setting-page">
                                <div class="wrapper-privacy-setting">
                                    <div class="menu-area" @click="onClickTerm('privacy')">
                                        <div class="text-detail">{{lbl.profile.menu.privacy}}</div>
                                        <img src="@/assets/icon/navbar_icon_drakblue.svg">
                                    </div>
                                    <div class="menu-area" @click="onClickTerm('terms')">
                                        <div class="text-detail">{{lbl.profile.menu.term}}</div>
                                        <img src="@/assets/icon/navbar_icon_drakblue.svg">
                                    </div>
                                    <div class="menu-area" @click="onClickMarketing()">
                                        <div class="text-detail">{{lbl.profile.menu.marketing}}</div>
                                        <img src="@/assets/icon/navbar_icon_drakblue.svg">
                                    </div>
                                    <div class="menu-area" @click="onClickCopyPersonal()">
                                        <div class="text-detail">{{lbl.profile.menu.raq_copy}}</div>
                                        <img src="@/assets/icon/navbar_icon_drakblue.svg">
                                    </div>
                                    <div class="menu-area" @click="onClickCopyPersonal()">
                                        <div class="text-detail" v-html="lbl.profile.menu.send_copy"></div>
                                        <img src="@/assets/icon/navbar_icon_drakblue.svg">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="text-area">{{lbl.profile.menu.text_contact}} <a href="tel:02-252-2979" class="contact-area">{{lbl.profile.menu.contact_number}}</a></div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import TopBarDark from "@/components/Layout/TopBarPage/TopBarDark.vue";
/**
 * @property {PrivacySettingModalController} controller (required)../Controller/ProductDescriptionModalController.js
 * @property {String} modalId (reqquired)
 */

export default {
    name: "PrivacySettingModal",
    props: {
        controller: Object,
        modalId: String,
        loadingModal: Object, //loding modal from master controller
    },
    components: {
        TopBarDark,
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            profile: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            console.log('change', this.content);
        },
        clickBack: function(){
            this.hide();
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.profile = config.profile;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        onClickTerm: function(type) {
            this.controller.termModal
                            .setType(type)
                            .show();
        },
        onClickMarketing: function() {
            this.controller.marketingModal.clearText()
                                          .setTag('profile')
                                          .show();
        },
        onClickCopyPersonal: function() {
            this.controller.copyPersonalModal.clearText()
                                             .setProfile(this.profile)
                                             .show();
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseText.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/input/BaseButton.scss";
.modal-privacy-setting{
    .page-wrapper {
        .page-bg {
            background-color: $white;
        }
    }
    .privacy-setting-page {
        .wrapper-privacy-setting {
            @include bg-curve();
            position: absolute;
            bottom: unset;
            padding: 20px 10px 10px;

            .menu-area {
                @extend %display-flex;
                justify-content: space-between;
                flex-wrap: nowrap;
                align-items: stretch;

                padding: {
                    top: 30px;
                    right: 30px;
                    left: 30px;
                }
                .text-detail {
                    text-align: left;
                    font-size: 1.25rem;
                    color: $deep-blue;

                    @include mini-mobile(){
                        font-size: 0.9rem;
                    }
                }
            }

        }
    }
    .modal-base-footer {
        position: absolute;
        bottom: 24px;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
        padding: 0 30px;

        .text-area {
            color: $pink;
            font-size: 0.9rem;

            .contact-area {
                text-decoration: underline;
                color: $pink;
            }
        }
    }
}
</style>

<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-privacy-setting{
    .modal-dialog{
        margin: 0;

        .modal-content{
            border: 0;

            .modal-body{
                padding: 0;
            }
        }
    }
}
</style>
